export default {
    brand: '매일국어T',

    buttons: {
        confirm: 'Confirm',
        cancel: 'Cancel',
        close: 'Close',
        next: 'Next',
        previous: 'Previous',
        start: 'Start',
        continue: 'Continue',
        stop: 'Stop',
        exit: 'Exit',
        save: 'Save',
        delete: 'Delete',
        edit: 'Edit',
        submit: 'Submit',
        reset: 'Reset',
        selectAll: 'Select All',
        end: 'End',
        assign: 'Assign',
        auth: {
            login: 'Log In',
            logout: 'Log Out',
        },
    },

    labels: {
        module: 'Activity',
        lesson: 'Activity Pack',
        star: 'Praise Star',
        waitingRoom: 'Waiting Room',
        screen: 'Board Screen',
        classroom: 'Classroom',
        student: 'Student',
        teacher: 'Teacher',
        grade: 'Grade',
        school: 'School',
        name: 'Name',
        date: 'Date',
        time: 'Time',
        duration: 'Duration',
        count: 'Count',
        result: 'Result',
        status: 'Status',
        mode: 'Mode',
        type: 'Type',
        level: 'Level',
        score: 'Score',
        question: 'Question',
        answer: 'Answer',
        online: 'Online',
        offline: 'Offline',
        list: 'List',
    },

    headerTitle: {
        waitingRoom: 'Waiting Room',
    },

    messages: {
        confirm: 'Are you sure you want to {action}?',
        success: '{action} has been completed.',
        error: 'An error has occurred.',
        networkError: 'A network error has occurred.',
        loading: 'Loading...',
        noData: 'No data available.',
        selectOption: 'Please select an option.',
    },

    status: {
        inProgress: 'In Progress',
        completed: 'Completed',
        pending: 'Pending',
        failed: 'Failed',
        locked: 'Locked',
        unlocked: 'Unlocked',
    },

    subject: {
        textbook: 'Textbook',
        korean: 'Korean',
        koreanActivity: 'Korean Activity',
        math: 'Math',
        science: 'Science',
        socialStudies: 'Social Studies',
        english: 'English',
    },

    screen: {
        basic: 'Home Screen',
        waitingRoom: 'Waiting Room',
        activity: 'Activity Screen',
        sessionResult: 'Session Result Screen',
        moduleResult: 'Activity Result Screen',
    },

    system: {
        networkError: {
            title: 'Internet connection is unstable.',
            message: 'Please wait a moment...',
            refresh: 'Refresh',
        },
        windowError: {
            closeManually: 'An error has occurred. Please close the window manually.',
        },
        audio: {
            playError: 'A problem occurred during audio playback.',
        },
    },

    accessibility: {
        alt: {
            starDraw: 'Star Gacha',
            seedLetter: 'Seed Letter',
            recentSessionResult: 'Recent Session Result',
            questionImage: 'Question image',
            explanationImage: 'Explanation image',
            photoMaterial: 'Photo material',
        },
        title: {
            listen: 'Listen',
            fold: 'Fold Writing Prompt',
            close: 'Close',
        },
    },

    units: {
        minute: 'min',
        second: 'sec',
        page: 'p',
        count: '',
        person: '',
        person2: '',
        times: '',
        level: 'Lv.',
        chapter: 'Ch.',
        etc: 'etc.',
        vote: '',
        notProvided: 'N/A',
        score: 'pts',
    },

    common: {
        button: {
            cancel: 'Cancel',
            confirm: 'Confirm',
        },
    },
};
